const Backbone = require('backbone');
const CartItemModel = require('app/models/store/client/cart/item');
const ProductHelper = require('app/views/store/common/helpers/product_helper');
const url = require('app/url');
const dustjs = require('dustjs');
const _optionErrorDust = require('common/products/_option_error.dust');
window.BCOM.views = window.BCOM.views || {};

var hiddenClass = 'hidden',
	currentStep = 1,
	ui = {};

var AddToCartView = Backbone.View.extend({
	initialize: function(options = {}) {
		this.options = options;

		ui.pricedGroup = $('#option-groups, .priced-option-buttons');
		ui.recommendedGroup = $('#recommended-options, .recommended-option-buttons');

		ui.stepGroup = $('.js-bar-step');
		ui.stepConfigure = $('.js-step-configure');
		ui.stepRecommended = $('.js-step-recommended');
		ui.cartQuantity = $('.js-cart-quantity');
		this.isProjectsQuickAdd = window.BCOM.util.getQueryStringParameter('isProjectsQuickAdd');

		this.setupOptionsDisplay();

		this.listenTo(Backbone, 'modal:close', this.moveToStepOne, this);
		this.listenTo(Backbone, 'finish:clicked product:complete product:incomplete', this._handleToolTip);
		this._handleToolTip();

		this.listenTo(Backbone, 'product:addToCart', this.addToCart);

		if (window.dataLayer.isConfigurePage && window.BCOM.device.isDesktop && !window.BCOM.data.saveAll && !window.BCOM.data.isPla) {
			$('#recommended-options').removeClass('hidden');
			$('.product-configuration-footer-content').addClass('hidden');
			$('.recommended-option-buttons').removeClass('hidden');
			$('#modal-add-to-cart').removeClass('narrow-configure-footer-display');
			$('.add-to-cart-wrap').removeClass('configure-is-active');
			$('#configure-page').addClass('configured');
		}
	},

	events: {
		'click #continue-without-items': 'addToCartWithoutRecommendedOptions',
		'click #go-to-recommended-options': 'transitionConfigSteps',
		'click .js-add-to-cart': 'addToCart'
	},

	moveToStepOne: function() {
		if (currentStep === 2) {
			this.transitionConfigSteps();
		}
	},

	configProduct: function($button, isProjectAdd, shoppingListIDs = [], activeFinish = {}) {
		const self = this,
			model = self.model,
			isAvailabilityByLocationError = model.hasAvailabilityByLocation() && !model.isAvailabilityByLocationSet(),
			isProductPageConfigured = model.isPreConfigured() && this.model.needsConfiguration(),
			isProjectsButton = $button.hasClass('js-post-to-project');

		if (this.options.purchaseView) {
			this.options.purchaseView.hideError();
		}

		if (!model.finishes.hasSelectedFinish()) {
			if (window.BCOM.device.isMobile && this.options.purchaseView) {
				self.options.purchaseView.showError({
					message: 'Please select a finish above',
					field: '.js-finishes-panel',
					label: '.js-selected-finish'
				});
			} else {
				Backbone.trigger('finish:notSelected');
			}
		} else if (isAvailabilityByLocationError) {
			Backbone.trigger('availability:displayErrors');
		} else if (window.dataLayer.isPla) {
			$button.button('loading');
			if (isProductPageConfigured && !isProjectsButton) {
				self._handleProductPageConfigured(isProjectAdd, shoppingListIDs, activeFinish, $button);
			} else {
				self.configRedirect({
					quantity: model.getQuantity()
				});
			}
		} else if (isProductPageConfigured && !isProjectsButton) {
			$button.button('loading');

			self._handleProductPageConfigured(isProjectAdd, shoppingListIDs, activeFinish, $button);
		} else if (window.BCOM.device.isDesktop) {
			return self.scrollToConfigure();
		}
	},

	configRedirect: function(options) {
		const shoppingListIDs = options.shoppingListIDs;

		let append = `quantity=${options.quantity}`;

		if (options.cartItemIds) {
			append += `&cartItemIds=${Array.isArray(options.cartItemIds) ? options.cartItemIds.join(',') : options.cartItemIds}`;
		}

		if (options.isProjectsQuickAdd) {
			append += '&isProjectsQuickAdd=true';
		} else if (shoppingListIDs && shoppingListIDs.length) {
			append += `&shoppingListIds=${shoppingListIDs.join(',')}`;
		}

		if (window.dataLayer.isPla) {
			append += '&displaypla=true';
		}
		if (
			this.model.finishes
				.getSelectedFinish()
				.get('status')
				.toLowerCase() === 'nonstock'
		) {
			append += '&ns=true';
		}
		if (options.project) {
			append += `&project=${options.project.name}:${options.project.id}`;
		}

		if (window.BCOM.theme.isBuild) {
			const url = this.model.finishes.getSelectedFinish().get('productLink');
			window.location.assign(`${url.replace('?', '/configure?')}&${append}`);
		} else if (window.BCOM.theme.isLivingDirect) {
			const selectedFinish = this.model.finishes.getSelectedFinish();
			const url = selectedFinish.get('productLink');
			window.location.assign(`${url.replace('.html', '/configure?') + append}&uid=${selectedFinish.get('uniqueId')}`);
		} else {
			window.location.assign(`${this.model.finishes.getSelectedFinish().get('productLink')}/configure?${append}`);
		}
	},

	redirect: function(model) {
		// Bypass may we suggest page for LDI sites.
		if (window.BCOM.theme.isLivingDirect) {
			window.location.assign('/checkout/cart');
			return;
		}

		if (window.dataLayer.shoppingListIDs) {
			const allShoppingListsIDs = window.dataLayer.shoppingListIDs;
			let redirectURL = `${
				window.location.href.split('configure')[0]
			}?showProjectConfirmation=true&uid=${window.BCOM.util.getQueryStringParameter('uid')}`;

			if (allShoppingListsIDs.length === 1) {
				redirectURL = `${redirectURL}&savedShoppingListID=${allShoppingListsIDs[0]}`;
			}
			window.location.assign(redirectURL);
		} else if (this.isProjectsQuickAdd) {
			const redirect = JSON.parse(window.localStorage.getItem('projectsQuickAddSource')).url;
			window.location.assign(redirect);
		} else if (
			window.dataLayer.hasAccessories ||
			(window.dataLayer.enableDynamicYieldMayWeSuggest && window.dataLayer.page !== 'product:configure')
		) {
			window.location.assign(`/cart/may-we-suggest?productUniqueId=${model.get('uniqueId')}&quantity=${model.get('quantity')}`);
		} else {
			window.location.assign('/checkout/cart');
		}
	},

	showErrorMessage: function(message, type) {
		if (!message || typeof message !== 'string') {
			message = 'There was an error adding your item to cart. Please&nbsp;<a href="/support/contact_us">contact us</a>.';
		}
		if (typeof type !== 'string') {
			type = 'danger';
		}
		window.BCOM.notifications.render(message, type);
	},

	shouldRedirectToConfigPage: function() {
		const desktopConfigRedirect =
				window.BCOM.device.isDesktop &&
				(this.model.hasRecommendedOption() || (this.model.needsConfiguration() && window.dataLayer.isPla)),
			mobileTabletConfigRedirect = !window.BCOM.device.isDesktop && this.model.needsConfiguration();

		return !window.dataLayer.isConfigurePage && (mobileTabletConfigRedirect || desktopConfigRedirect);
	},

	_getRecommendedOptionFinishesForItems: function(items, recommendedOptions) {
		if (!items || items.length === 0 || !recommendedOptions || recommendedOptions.length === 0) {
			return [];
		}

		// Extract map of uniqueId to finish from recommended options.
		const finishMap = recommendedOptions.reduce((obj, recommendedOption) => {
			recommendedOption.products.forEach((product) => {
				product.finishes.forEach((finish) => {
					obj[finish.uniqueId] = finish;
				});
			});
			return obj;
		}, {});

		// Gather finishes for requested subItems.
		return items.reduce((arr, item) => {
			const finish = finishMap[item.uniqueId];
			if (finish) {
				arr.push({ item, finish });
			}
			return arr;
		}, []);
	},

	addToCart: function(event) {
		// This will prevent the event from bubbling up once it's triggered.
		event.stopPropagation();
		const $button = $(event.currentTarget);

		// Checks to see if this button call comes from a save to project, if so redirect before adding to cart.
		if (!this.isProjectsQuickAdd && $button.hasClass('js-for-projects')) {
			this.redirect(this.model);
			return;
		}

		let activeFinish;

		if ($button.hasClass('js-configure-button')) {
			this.scrollToConfigure();
			return;
		}

		if (!this._canAddToCart($button)) {
			return;
		}

		// putting this here to prevent JS errors when product isn't configured yet.
		activeFinish = this.model.finishes.getSelectedFinish().toJSON();

		if (this.shouldRedirectToConfigPage()) {
			return this.configProduct($button, null, null, activeFinish);
		}

		$button.button('loading');

		this._saveItemToCart(
			window.dataLayer.hasRecommendedOption,
			function(response, model) {
				if (response.status === 1) {
					if (this.isProjectsQuickAdd) {
						return this.redirect(model);
					}
					Backbone.trigger('addToCart:productAdded', model);
					Backbone.trigger('omniture:productaddtocart', 'product-page', response, model, activeFinish, this.redirect);
				} else if (window.dataLayer.hasRecommendedOption) {
					this.redirect(model);
				} else {
					this._handleResponseError(response);
					$button.button('reset');
				}
			}.bind(this)
		);
	},

	scrollToConfigure: function() {
		const $scrollTarget = $('#js-scroll-options');
		const $stickyHeader = $('#productHeaderBlock');

		// LDI has a sticky header so we need to adjust the offset to reflect that
		if (window.BCOM.theme.isLivingDirect && $scrollTarget.length > 0 && $stickyHeader.length > 0) {
			$('html, body').animate(
				{
					scrollTop: $scrollTarget.offset().top - $stickyHeader.height()
				},
				200
			);
		} else if ($scrollTarget.length > 0) {
			$('html, body').animate(
				{
					scrollTop: $scrollTarget.offset().top
				},
				200
			);
		}
	},

	setupOptionsDisplay: function() {
		if (window.dataLayer.isConfigurePage && window.BCOM.device.isDesktop && !window.BCOM.data.saveAll && !window.BCOM.data.isPla) {
			ui.pricedGroup.addClass(hiddenClass);
			$('.js-config-progress').hide();
			return;
		}

		var hasPricedOptionsInModal = this.model.hasPricedOptionsExcludingInstall(),
			hasRecommendedOptions = this.model.hasRecommendedOption();

		if (hasPricedOptionsInModal && hasRecommendedOptions) {
			ui.recommendedGroup.addClass(hiddenClass);
		} else if (!hasPricedOptionsInModal && hasRecommendedOptions) {
			ui.pricedGroup.addClass(hiddenClass);
			$('.js-config-progress').hide();
		}
	},

	handleRedirect(shoppingListIDs, cartItemIds, isProjectsQuickAdd = false, project = {}) {
		const params = url.deserializeParameters(),
			quantity = params.quantity || this.model.get('quantity') || 1;

		if (this.shouldRedirectToConfigPage()) {
			this.configRedirect({
				shoppingListIDs,
				cartItemIds,
				quantity,
				isProjectsQuickAdd,
				project
			});
			return true;
		} else if (window.dataLayer.hasRecommendedOption || (window.dataLayer.hasAccessories && !shoppingListIDs)) {
			this.redirect(this.model);
			return true;
		} else {
			return false;
		}
	},

	_handleConfigToRecReqOrCart: function(event) {
		if (this.model.isConfigured() && this.model.hasRecommendedOption()) {
			this._saveItem(false, (response, model) => {
				if (response.status !== 1) {
					this._handleResponseError(response);
				} else {
					if (this.isProjectsQuickAdd) {
						this.model.set('parentItemKey', response.items.find((item) => (item.uniquId = model.get('uniqueId'))).itemKey);
						return this.handleConfiguredProductAdded(event);
					}
					const activeFinish = this.model.finishes.getSelectedFinish().toJSON();
					window.BCOM.util.trackCartAddition(model.attributes);
					Backbone.trigger('addToCart:productAdded', model);
					Backbone.trigger('cart:quantityChanged', parseInt(ui.cartQuantity.text(), 10) + parseInt(model.get('quantity'), 10));
					Backbone.trigger(
						'omniture:productaddtocart',
						'configured-product',
						response,
						model,
						activeFinish,
						this.handleConfiguredProductAdded.bind(this, event)
					);
				}
			});
		} else {
			this.addToCart.call(this, event);
		}
	},

	handleConfiguredProductAdded(event) {
		currentStep = currentStep === 1 ? 2 : 1;
		const isFirstStep = currentStep === 1;
		ui.recommendedGroup.toggleClass(hiddenClass, !isFirstStep);
		ui.pricedGroup.toggleClass(hiddenClass, !isFirstStep);

		if (currentStep === 2) {
			$('#recommended-options').removeClass('hidden');
			$('.product-configuration-footer-content').addClass('hidden');
			$('.recommended-option-buttons').removeClass('hidden');
			$('#modal-add-to-cart').removeClass('narrow-configure-footer-display');
			$('.add-to-cart-wrap').removeClass('configure-is-active');
			$('#configure-page').addClass('configured');
		} else {
			ui.stepGroup.removeClass('bar-recommended').addClass('bar-configure');
			ui.stepRecommended.removeClass('step');
			ui.stepConfigure.addClass('step');
		}

		if (event) {
			Backbone.trigger('modal:contentChanged modal:resetToTop');
		}
	},

	transitionConfigSteps: function(event) {
		if (this.model.isConfigured()) {
			this._handleConfigToRecReqOrCart.call(this, event);
		}
	},

	addToCartWithoutRecommendedOptions: function(event) {
		var self = this,
			$button = this.$(event.currentTarget);

		$button.button('loading');
		if ($button.hasClass('js-projects-add')) {
			Backbone.trigger('omniture:projects', 'complex_products', 'no_thanks');
		}

		if (window.BCOM.data.saveAll && !this.isProjectsQuickAdd) {
			this._saveItem(false, function(response, model) {
				if (response.status === 1) {
					const activeFinish = self.model.finishes.getSelectedFinish().toJSON();
					Backbone.trigger('addToCart:productAdded', model);
					Backbone.trigger('omniture:productaddtocart', 'no-recommended-option', response, model, activeFinish, self.redirect);
				} else {
					self._handleResponseError(response);
					$button.button('reset');
				}
			});
		} else {
			this.model.recommendedOptions.invoke('set', {
				isNeeded: false
			});

			var cartItemModel = new CartItemModel({
				quantity: this.model.getQuantity(),
				uniqueId: this.model.finishes.getSelectedFinish().get('uniqueId')
			});

			this.redirect(cartItemModel);
		}
	},

	_trackSaveSubItems: function(model) {
		if (!model.get('saveSubItems')) {
			return;
		}
		const subItems = model.get('subItems');
		const recommendedOptions = this.model.get('recommendedOptions');
		const itemFinishes = this._getRecommendedOptionFinishesForItems(subItems, recommendedOptions);
		itemFinishes.forEach(({ item, finish }) => {
			window.BCOM.util.trackCartSubItemAddition({
				uniqueId: item.uniqueId,
				quantity: item.quantity,
				finish
			});
		});
	},

	_trackSaveItemToCart: function(savedModel) {
		try {
			window.BCOM.util.trackCartAddition(savedModel.attributes);
			this._trackSaveSubItems(savedModel);
		} catch (error) {
			window.clientErrorHandler(error);
		}
	},

	_saveItemToCart: function(saveSubItems, callback) {
		const params = url.deserializeParameters(),
			sessionCartId = !window.BCOM.device.isDesktop ? window.dataLayer.shoppingListIDs && window.dataLayer.shoppingListIDs[0] : null,
			cartConfigOptions = ProductHelper.getDefaultCartItemModelConfig(
				this.model,
				saveSubItems,
				window.BCOM.data.saveAll,
				params.quantity,
				sessionCartId,
				params.searchId
			),
			cartItemModel = new CartItemModel(cartConfigOptions);

		if (this.isProjectsQuickAdd) {
			cartItemModel.set('isProjectsQuickAdd', true);
		}

		if (saveSubItems && cartConfigOptions.subItems.length === 0 && !this.model.hasPricedOptions()) {
			this.redirect(cartItemModel);
		} else {
			cartItemModel.save(null, {
				success: (model, response) => {
					this._trackSaveItemToCart(model);
					this.model.set('cartItemId', response.cartItemId);
					callback(response, model);
				},
				error: (model, response) => {
					callback(response, model);
				}
			});
		}
	},

	_saveItem: function(saveSubItems, callback) {
		this._saveItemToCart.call(this, saveSubItems, callback);
	},

	_handleResponseError: function(response) {
		var self = this;
		if (typeof response.notification === 'object') {
			this.showErrorMessage(response.notification.notification, response.notification.notificationType);
		} else if (response.optionError) {
			dustjs.render(_optionErrorDust, response, function(err, html) {
				self.showErrorMessage(html, 'warning');
			});
		} else if (response.prodOptionError) {
			Backbone.trigger('priceOption:validationError', response);
		} else {
			// Show generic error
			this.showErrorMessage();
		}
	},

	_handleProductPageConfigured: function(isProjectAdd = false, shoppingListIDs = [], activeFinish = {}, $button) {
		if (this.shouldSaveBeforeRedirect() && !isProjectAdd) {
			this._saveItem(false, (response, model) => {
				if (response.status === 1) {
					Backbone.trigger('addToCart:productAdded', model);
					Backbone.trigger(
						'omniture:productaddtocart',
						'product-page-configured',
						response,
						model,
						activeFinish,
						this.configRedirect({
							quantity: model.get('quantity'),
							cartItemIds: response.cartItemId
						})
					);
				} else {
					$button.button('reset');
					this._handleResponseError(response);
				}
			});
		} else {
			/*
			 * Save IDs here
			 */

			this.configRedirect({
				shoppingListIDs,
				quantity: this.model.getQuantity()
			});
		}
	},

	shouldSaveBeforeRedirect: function() {
		const shouldAddItemBecauseDesktop = window.BCOM.device.isDesktop && !window.dataLayer.isPla;
		return shouldAddItemBecauseDesktop || !this.model.hasPricedOptionsExcludingInstall();
	},

	_canAddToCart: function($allButtons) {
		const $button = $allButtons.filter(function() {
				return !$(this).hasClass('configure-button');
			}),
			isDesktopProductPage = window.BCOM.device.isDesktop && !window.dataLayer.isConfigurePage,
			scrollToConfigure =
				((this.model.needsConfiguration() && !this.model.isPreConfigured()) || $button.data('isConfigure')) &&
				!window.dataLayer.isPla,
			$squareFootage = parseInt(String($('#square-foot-text-input').val()), 10),
			isReqRecPage = window.dataLayer.page === 'product:configure';

		if (this.options.purchaseView) {
			this.options.purchaseView.hideError();
		}

		if (!this.model.finishes.hasSelectedFinish()) {
			if (window.BCOM.device.isMobile && this.options.purchaseView) {
				this.options.purchaseView.showError({
					message: 'Please select a finish above',
					field: '.js-finishes-panel',
					label: '.js-selected-finish'
				});
			} else {
				Backbone.trigger('finish:notSelected');
			}

			return false;
		} else if (this.model.hasAvailabilityByLocation() && !this.model.isAvailabilityByLocationSet()) {
			Backbone.trigger('availability:displayErrors');
			return false;
		} else if (isDesktopProductPage && scrollToConfigure) {
			this.scrollToConfigure();
			return false;
		} else if (this.model.get('hasSquareFootage') && !$squareFootage && !isReqRecPage) {
			const $scrollTarget = $('.js-total-sq-ft');
			$scrollTarget.addClass('error-highlight');
			if ($scrollTarget.length > 0 && !window.BCOM.util.isElementInViewport($scrollTarget)) {
				$('html, body').animate(
					{
						scrollTop: $scrollTarget.offset().top
					},
					200
				);
			}
			return false;
		} else if (window.dataLayer.hasInvalidKeyCode && !window.dataLayer.isLocalUser) {
			const $keyCodeError = $('.js-key-code-message span');

			$('.js-key-code-message .js-icon').remove();
			$keyCodeError.addClass('error-highlight');

			$('html, body').animate(
				{
					scrollTop: $keyCodeError.offset().top - 100
				},
				500
			);
			return false;
		}

		return true;
	},

	_handleToolTip: function() {
		if (window.BCOM.device.isDesktop && !window.dataLayer.isConfigurePage) {
			var toolTip,
				$addToCartButtons = $('.js-configure-product, .js-add-to-cart, .js-post-to-project');

			if (window.BCOM.theme.isLivingDirect) {
				// LDI has un-related add-to-cart buttons on a product page (other related/accessory _product_card templates)
				// This needs to be scoped to the add-to-cart buttons which apply only to the main product on the page.
				$addToCartButtons = this.$('.js-configure-product, .js-add-to-cart, .js-post-to-project');
			}

			if (!this.model.finishes.hasSelectedFinish()) {
				toolTip = 'Please select a finish';
			} else if (this.model.needsConfiguration() && !this.model.isConfigured() && !window.dataLayer.isPla) {
				toolTip = 'Please configure';
			}

			if (toolTip) {
				$addToCartButtons.tooltip({
					title: toolTip
				});
				// @ts-ignore
				$addToCartButtons.tooltip('enable');
			} else {
				// @ts-ignore
				$addToCartButtons.tooltip('disable');
			}
		}
	}
});

module.exports = AddToCartView;
